import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "header": "🎬 CineVerse 🎥",
          "tv_series": "TV Series",
          "TV Series": "TV Series",
          "Movies": "Movies",
          "Trending": "Trending",
          "Like": "Like",
          "Search": "Search",
          "DISCOVER MOVIES": "Discover Movies",
          "TRENDING TODAY": "Trending Today",
          "DISCOVER SERIES": "Discover Series",
          "Liked Movies": "Liked Movies",
          "SEARCH MOVIES": "Search Movies",
          "SEARCH TV SERIES": "Search TV Series",
          "Action": "Action",
          "Adventure": "Adventure",
          "Animation": "Animation",
          "Comedy": "Comedy",
          "Crime": "Crime",
          "Documentary": "Documentary",
          "Drama": "Drama",
          "Family": "Family",
          "Fantasy": "Fantasy",
          "History": "History",
          "Horror": "Horror",
          "Music": "Music",
          "Mystery": "Mystery",
          "Romance": "Romance",
          "Science Fiction": "Science Fiction",
          "TV Movie": "TV Movie",
          "Thriller": "Thriller",
          "War": "War",
          "Western": "Western",
          "Action & Adventure": "Action & Adventure",
          "Kids": "Kids",
          "News": "News",
          "Reality": "Reality",
          "Sci-Fi & Fantasy": "Sci-Fi & Fantasy",
          "Soap": "Soap",
          "Talk": "Talk",
          "War & Politics": "War & Politics",
          "Favourite":"Favourite",
          "Today":"Today",
          "Discover":"Discover",
          "Series":"Series",
          "TV":"TV"
        }
      },
      fr: {
        translation: {
          "header": "🎬 CinéMonde 🎥",
          "tv_series": "Série TV",
          "TV Series": "Série TV",
          "Movies": "Film",
          "Trending": "Tendances",
          "Like": "Aimer",
          "Search": "Chercher",
          "DISCOVER MOVIES": "Découvrir des films",
          "TRENDING TODAY": "Tendances aujourd'hui",
          "DISCOVER SERIES": "Découvrir des séries",
          "Liked Movies": "Films aimés",
          "SEARCH MOVIES": "Rechercher des films",
          "SEARCH TV SERIES": "Rechercher des séries TV",
          "Action": "Action",
          "Adventure": "Aventure",
          "Animation": "Animation",
          "Comedy": "Comédie",
          "Crime": "Crime",
          "Documentary": "Documentaire",
          "Drama": "Drame",
          "Family": "Famille",
          "Fantasy": "Fantaisie",
          "History": "Histoire",
          "Horror": "Horreur",
          "Music": "Musique",
          "Mystery": "Mystère",
          "Romance": "Romance",
          "Science Fiction": "Science-fiction",
          "TV Movie": "Téléfilm",
          "Thriller": "Thriller",
          "War": "Guerre",
          "Western": "Western",
          "Action & Adventure": "Action et aventure",
          "Kids": "Enfants",
          "News": "Actualités",
          "Reality": "Réalité",
          "Sci-Fi & Fantasy": "Science-fiction et fantaisie",
          "Soap": "Feuilleton",
          "Talk": "Talk-show",
          "War & Politics": "Guerre et politique",
          "Favourite": "Favori",
    "Today": "Aujourd'hui",
    "Discover": "Découvrir",
    "Series": "Séries",
    "TV": "TV"
        }
      },
      es: {
        translation: {
          "header": "🎬 CineVerso 🎥",
          "tv_series": "Series de TV",
          "TV Series": "Series de TV",
          "Movies": "Película",
          "Trending": "Tendencias",
          "Like": "Me gusta",
          "Search": "Buscar",
          "DISCOVER MOVIES": "Descubrir películas",
          "TRENDING TODAY": "Tendencias de hoy",
          "DISCOVER SERIES": "Descubrir series",
          "Liked Movies": "Películas favoritas",
          "SEARCH MOVIES": "Buscar películas",
          "SEARCH TV SERIES": "Buscar series de TV",
          "Action": "Acción",
          "Adventure": "Aventura",
          "Animation": "Animación",
          "Comedy": "Comedia",
          "Crime": "Crimen",
          "Documentary": "Documental",
          "Drama": "Drama",
          "Family": "Familia",
          "Fantasy": "Fantasía",
          "History": "Historia",
          "Horror": "Terror",
          "Music": "Música",
          "Mystery": "Misterio",
          "Romance": "Romance",
          "Science Fiction": "Ciencia ficción",
          "TV Movie": "Película de TV",
          "Thriller": "Suspenso",
          "War": "Guerra",
          "Western": "Western",
          "Action & Adventure": "Acción y aventura",
          "Kids": "Niños",
          "News": "Noticias",
          "Reality": "Realidad",
          "Sci-Fi & Fantasy": "Ciencia ficción y fantasía",
          "Soap": "Telenovela",
          "Talk": "Talk-show",
          "War & Politics": "Guerra y política",
          "Favourite": "Favorito",
    "Today": "Hoy",
    "Discover": "Descubrir",
    "TV": "TV"
        }
      },
      hi: {
        translation: {
          "header": "🎬 सिनेवर्स 🎥",
          "tv_series": "टीवी श्रृंखला",
          "TV Series": "टीवी श्रृंखला",
          "Movies": "फिल्म",
          "Trending": "प्रवृत्तियाँ",
          "Like": "पसंद करें",
          "Search": "खोजें",
          "DISCOVER MOVIES": "फिल्में खोजें",
          "TRENDING TODAY": "आज की प्रवृत्तियाँ",
          "DISCOVER SERIES": "श्रृंखला खोजें",
          "Liked Movies": "पसंदीदा फिल्में",
          "SEARCH MOVIES": "फिल्में खोजें",
          "SEARCH TV SERIES": "टीवी श्रृंखला खोजें",
          "Action": "एक्शन",
          "Adventure": "साहसिक",
          "Animation": "एनिमेशन",
          "Comedy": "कॉमेडी",
          "Crime": "अपराध",
          "Documentary": "डॉक्यूमेंट्री",
          "Drama": "ड्रामा",
          "Family": "परिवार",
          "Fantasy": "कल्पना",
          "History": "इतिहास",
          "Horror": "डरावनी",
          "Music": "संगीत",
          "Mystery": "रहस्य",
          "Romance": "रोमांस",
          "Science Fiction": "विज्ञान कल्पना",
          "TV Movie": "टीवी मूवी",
          "Thriller": "थ्रिलर",
          "War": "युद्ध",
          "Western": "पश्चिमी",
          "Action & Adventure": "एक्शन और एडवेंचर",
          "Kids": "बच्चे",
          "News": "समाचार",
          "Reality": "वास्तविकता",
          "Sci-Fi & Fantasy": "विज्ञान-कल्पना और कल्पना",
          "Soap": "सोप",
          "Talk": "टॉक शो",
          "War & Politics": "युद्ध और राजनीति",
          "Favourite": "पसंदीदा",
    "Today": "आज",
    "Discover": "खोजें",
    "Series": "श्रृंखला",
    "TV": "टीवी"
        }
      },
      ja: {
        translation: {
          "header": "🎬 シネバース 🎥",
          "tv_series": "テレビシリーズ",
          "TV Series": "テレビシリーズ",
          "Movies": "映画",
          "Trending": "トレンド",
          "Like": "いいね",
          "Search": "検索",
          "DISCOVER MOVIES": "映画を探す",
          "TRENDING TODAY": "今日のトレンド",
          "DISCOVER SERIES": "シリーズを探す",
          "Liked Movies": "お気に入りの映画",
          "SEARCH MOVIES": "映画を検索",
          "SEARCH TV SERIES": "テレビシリーズを検索",
          "Action": "アクション",
          "Adventure": "冒険",
          "Animation": "アニメーション",
          "Comedy": "コメディ",
          "Crime": "犯罪",
          "Documentary": "ドキュメンタリー",
          "Drama": "ドラマ",
          "Family": "家族",
          "Fantasy": "ファンタジー",
          "History": "歴史",
          "Horror": "ホラー",
          "Music": "音楽",
          "Mystery": "ミステリー",
          "Romance": "ロマンス",
          "Science Fiction": "SF",
          "TV Movie": "テレビ映画",
          "Thriller": "スリラー",
          "War": "戦争",
          "Western": "西部劇",
          "Action & Adventure": "アクション＆アドベンチャー",
          "Kids": "子供",
          "News": "ニュース",
          "Reality": "リアリティ",
          "Sci-Fi & Fantasy": "SF＆ファンタジー",
          "Soap": "ソープ",
          "Talk": "トークショー",
          "War & Politics": "戦争と政治",
          "Favourite": "お気に入り",
    "Today": "今日",
    "Discover": "発見する",
    "Series": "シリーズ",
    "TV": "テレビ"
        }
      },
      mr: {
        translation: {
          "header": "🎬 सिनेविश्व 🎥",
          "tv_series": "टीव्ही मालिका",
          "TV Series": "टीव्ही मालिका",
          "Movies": "चित्रपट",
          "Trending": "ट्रेंडिंग",
          "Like": "आवडले",
          "Search": "शोधा",
          "DISCOVER MOVIES": "चित्रपट शोधा",
          "TRENDING TODAY": "आजचे ट्रेंड",
          "DISCOVER SERIES": "शृंखला शोधा",
          "Liked Movies": "आवडलेल्या चित्रपट",
          "SEARCH MOVIES": "चित्रपट शोधा",
          "SEARCH TV SERIES": "टीव्ही शृंखला शोधा",
          "Action": "कृती",
          "Adventure": "साहस",
          "Animation": "अ‍ॅनिमेशन",
          "Comedy": "कॉमेडी",
          "Crime": "गुन्हा",
          "Documentary": "माहितीपट",
          "Drama": "नाट्य",
          "Family": "कुटुंब",
          "Fantasy": "काल्पनिक",
          "History": "इतिहास",
          "Horror": "भीती",
          "Music": "संगीत",
          "Mystery": "गूढ",
          "Romance": "प्रेमकथा",
          "Science Fiction": "विज्ञान कथा",
          "TV Movie": "टीव्ही चित्रपट",
          "Thriller": "थ्रिलर",
          "War": "युद्ध",
          "Western": "पश्चिमी",
          "Action & Adventure": "कृती आणि साहस",
          "Kids": "मुलं",
          "News": "बातम्या",
          "Reality": "वास्तविकता",
          "Sci-Fi & Fantasy": "विज्ञान कथा आणि कल्पनारम्यता",
          "Soap": "सोप ओपेरा",
          "Talk": "टॉक शो",
          "War & Politics": "युद्ध आणि राजकारण",
          "Favourite": "आवडता",
          "Today": "आज",
          "Discover": "शोधा",
          "TV": "टीवी"
        }
      },
      zh: {
        translation: {
          "header": "🎬 电影世界 🎥",
          "tv_series": "电视剧",
          "TV Series": "电视剧",
          "Movies": "电影",
          "Trending": "趋势",
          "Like": "喜欢",
          "Search": "搜索",
          "DISCOVER MOVIES": "发现电影",
          "TRENDING TODAY": "今日趋势",
          "DISCOVER SERIES": "发现系列",
          "Liked Movies": "喜欢的电影",
          "SEARCH MOVIES": "搜索电影",
          "SEARCH TV SERIES": "搜索电视剧",
          "Action": "动作",
          "Adventure": "冒险",
          "Animation": "动画",
          "Comedy": "喜剧",
          "Crime": "犯罪",
          "Documentary": "纪录片",
          "Drama": "剧情",
          "Family": "家庭",
          "Fantasy": "奇幻",
          "History": "历史",
          "Horror": "恐怖",
          "Music": "音乐",
          "Mystery": "悬疑",
          "Romance": "爱情",
          "Science Fiction": "科幻",
          "TV Movie": "电视电影",
          "Thriller": "惊悚",
          "War": "战争",
          "Western": "西部片",
          "Action & Adventure": "动作与冒险",
          "Kids": "儿童",
          "News": "新闻",
          "Reality": "真人秀",
          "Sci-Fi & Fantasy": "科幻与奇幻",
          "Soap": "肥皂剧",
          "Talk": "谈话节目",
          "War & Politics": "战争与政治",
          "Favourite": "最喜欢",
          "Today": "今天",
          "Discover": "发现",
          "Series": "系列",
          "TV": "电视"
        }
      }
    },
    lng: "en", // default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
